<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        :loading="loading"
        v-bind="attrs"
        v-on="on"
        class="mx-2"
        fab
        dark
        x-small
        color="primary"
        @click="loadMembresDugroupe(groupe.id)"
      >
        <v-icon dark>
          mdi-reload
        </v-icon>
      </v-btn>
    </template>
    <span>Générer les ménages</span>
  </v-tooltip>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      loading: false,
      membres: [],
    };
  },
  props: {
    groupe: {
      required: true,
    },
  },
  methods: {
    ...mapActions({
      GetMembresDuGroupe: "Membres/GetMembresDuGroupe",
      generateMenages: "Utils/generateMenages",
    }),

    loadMembresDugroupe(idGroupe) {
      let self = this;
      this.loading = true;
      this.GetMembresDuGroupe(idGroupe).then(() => {
        //console.log(self.MembresDugroupe);
        var objet = {
          MembresDugroupe: self.MembresDugroupe,
          groupe: self.groupe,
        };
        console.log(objet);
        self.generateMenages(objet).then(() => {
          self.loading = false;
          self.$emit("menageGenerated")
        });
      });
    },
  },
  computed: {
    ...mapState({
      MembresDugroupe: (state) => state.Membres.MembresDuGroupe,
    }),
  },
};
</script>

<style scoped></style>
